import { c as _c } from "react/compiler-runtime";
import type { EntityBankAccount } from '@onefootprint/types';
import { useTranslation } from 'react-i18next';
import type { LinkedAccount } from '../bank-account-fields.types';
import DateRow from '../date-row';
import InnerTable from '../inner-table/inner-table';
import MoneyRow from '../money-row';
import StatusRow from '../status-row/status-row';
type AccountBalancesProps = {
  accounts: LinkedAccount[];
  selectedBankAccount?: EntityBankAccount;
};
const AccountBalances = t0 => {
  const $ = _c(43);
  const {
    accounts,
    selectedBankAccount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.financial.balances"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== accounts || $[2] !== selectedBankAccount) {
    t2 = selectedBankAccount?.alias ? accounts.find(account => account.accountId === selectedBankAccount.alias) : null;
    $[1] = accounts;
    $[2] = selectedBankAccount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const visibleAccount = t2;
  if (!visibleAccount?.balances) {
    return null;
  }
  const {
    balances
  } = visibleAccount;
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp2);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = balances.available || 0;
  const t6 = balances.currency || "USD";
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <MoneyRow label={t4} value={t5} currency={t6} />;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t(_temp3);
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = balances.current || 0;
  const t10 = balances.currency || "USD";
  let t11;
  if ($[14] !== t10 || $[15] !== t8 || $[16] !== t9) {
    t11 = <MoneyRow label={t8} value={t9} currency={t10} />;
    $[14] = t10;
    $[15] = t8;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== balances.currency || $[19] !== balances.limit || $[20] !== t) {
    t12 = balances.limit !== null && balances.limit !== undefined && <MoneyRow label={t(_temp4)} value={balances.limit} currency={balances.currency || "USD"} />;
    $[18] = balances.currency;
    $[19] = balances.limit;
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = t(_temp5);
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = balances.balanceDate || "";
  let t15;
  if ($[24] !== t13 || $[25] !== t14) {
    t15 = <DateRow label={t13} date={t14} variant="relative" />;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t) {
    t16 = t(_temp6);
    $[27] = t;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t || $[30] !== visibleAccount.isClosed) {
    t17 = visibleAccount.isClosed ? t(_temp7) : t(_temp8);
    $[29] = t;
    $[30] = visibleAccount.isClosed;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = visibleAccount.isClosed ? "negative" : "positive";
  let t19;
  if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
    t19 = <StatusRow label={t16} status={t17} variant={t18} />;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t11 || $[37] !== t12 || $[38] !== t15 || $[39] !== t19 || $[40] !== t3 || $[41] !== t7) {
    t20 = <InnerTable title={t3}>{t7}{t11}{t12}{t15}{t19}</InnerTable>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t15;
    $[39] = t19;
    $[40] = t3;
    $[41] = t7;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
};
export default AccountBalances;
function _temp($) {
  return $.accountBalance;
}
function _temp2($_0) {
  return $_0.available;
}
function _temp3($_1) {
  return $_1.current;
}
function _temp4($_2) {
  return $_2.limit;
}
function _temp5($_3) {
  return $_3.lastUpdated;
}
function _temp6($_4) {
  return $_4.status.title;
}
function _temp7($_5) {
  return $_5.status.closed;
}
function _temp8($_6) {
  return $_6.status.open;
}